/* eslint-disable import/prefer-default-export */
import wrapWithProvider from './src/store/wrap-with-provider';

export const wrapRootElement = wrapWithProvider;

// https://github.com/gatsbyjs/gatsby/tree/master/examples/using-redux
